import { render } from "./ArticleView.vue?vue&type=template&id=260fd652&scoped=true"
import script from "./ArticleView.vue?vue&type=script&lang=js"
export * from "./ArticleView.vue?vue&type=script&lang=js"

import "./ArticleView.vue?vue&type=style&index=0&id=260fd652&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260fd652"]])

export default __exports__